import z from 'zod'
import { ProcessingTypeEnum } from '../../domain/enums/ProcessingType.enum'
import { ProcessingVariableEnum } from '../../domain/enums/ProcessingVariable.enum'
import { ProcessingResolutionEnum } from '../../domain/enums/ProcessingResolution.enum'

export const CreateForestInventoryStratumSchema = z
	.object({
		description: z.string(),
		processingDate: z.date(),
		referenceDate: z.date(),
		isSubsequent: z.boolean(),
		stumpHeight: z.number(),
		measurementId: z.string(),
		significanceLevel: z.number(),
		officialInventory: z.boolean(),
		newInventory: z.boolean(),
		type: z.enum(ProcessingTypeEnum),
		variables: z.array(z.enum(ProcessingVariableEnum)),
		resolution: z.enum(ProcessingResolutionEnum),
		images: z.array(z.string()),
		aggregatingVariables: z.string(),
		products: z.array(z.any()),
		volumeInventoryStratumId: z.string().optional(),
	})
	.transform((data) =>
		JSON.stringify([
			{
				eifl_ds_descricao: data.description,
				eifl_dt_processamento: data.processingDate.toISOString(),
				eifl_dt_referencia: data.referenceDate.toISOString(),
				eifl_is_subsequente: data.isSubsequent,
				eifl_md_altura_toco: data.stumpHeight,
				eifl_tx_var_agregadoras: data.aggregatingVariables,
				fk_mdco_medicao: data.measurementId,
				fk_eicb_estrato_invcbg: data.volumeInventoryStratumId,
				eifl_cd_codigo: 0,
				eifl_md_volume_florestal: 0,
				eifl_md_nivel_significancia: data.significanceLevel,
				eifl_tx_status: '',
				eifl_tx_query_gerada: '',
				InventarioOficial: data.officialInventory,
				NovoInventario: data.newInventory,
				InventarioProdutos: data.products,
				fk_orsv_ordem_servico: null,
				eifl_is_singletrees: false,
				eifl_nm_metodologia_nfustes: undefined,
				eifl_enum_tipo_processamento: data.type,
				eifl_list_variaveis_processamento: data.variables,
				eifl_enum_resolucao_processamento: data.resolution,
				ids_imagens_processamento: data.images,
			},
		]),
	)
